import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ResearcherResourceCenter from "./sections/ResearcherResourceCenter";
import PortalBenefits from "./sections/PortalBenefits";
import TheProcess from "./sections/TheProcess";
import ClinicalImpactByTheNumbers from "./sections/ClinicalImpactByTheNumbers";
import VoicesFromTheTable from "./sections/VoicesFromTheTable";
import PretPourLeGrandSaut from "./sections/PretPourLeGrandSaut";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ResearcherResourceCenter />
      <PortalBenefits />
      <TheProcess />
      <ClinicalImpactByTheNumbers />
      <VoicesFromTheTable />
      <PretPourLeGrandSaut />
      <Footer />
    </div>;
}